import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Masculino from "../pages/Masculino";
import Feminino from "../pages/Feminino";
import Geral from "../pages/Geral";
import Dashboard from "../pages/Dashboard";
import GTM from "../components/GTM/gtm";
import Perfumes from "../pages/Perfumes";

export default function AppRouter() {
  return (
    <BrowserRouter>
    <GTM></GTM>
      <Routes>
        <Route path="/" element={<Perfumes />} />
        <Route path="/moda" element={<Masculino />} />
        <Route path="/divas" element={<Feminino />} />
        <Route path="/promos" element={<Geral />} />
        <Route path="/Perfumes" element={<Perfumes />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}